import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import activeTabSlice from "./slices/activeTabSlice";
import branchSlice, { setBranchByBusinress } from "./slices/branch";
import userProSlice, { setUserPro } from "./slices/businessPro";
import clientSlice from "./slices/clientSlice";
import dialogTypeSlice from "./slices/dialogTypeSlice";
import userRoutesSlice, { setUserRoutes } from "./slices/path";
import selectedBranch from "./slices/selectedBranch";
import selectedChatSlice, { setSelectedChat } from "./slices/selectedChatSlice";
import selectedClientSlice from "./slices/selectedClientSlice";
import subscriptionSlice from "./slices/subscription";
import tabActiveSlice from "./slices/tabActiveSlice";
import userSlice, { setUser } from "./slices/userSlice";
const rootReducer = combineReducers({
  branchSlices: branchSlice,
  clientTab: clientSlice,
  activeTab: activeTabSlice,
  tabActive: tabActiveSlice,
  activeChat: selectedChatSlice,
  user: userSlice,
  subscription: subscriptionSlice,
  selectedClient: selectedClientSlice,
  dialogType: dialogTypeSlice,
  userProSlice: userProSlice,
  routes: userRoutesSlice,
  selectedBranch: selectedBranch,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
const user = JSON.parse(localStorage.getItem("user-data"));
const branchIds = JSON.parse(localStorage.getItem("branchIds"));
store.dispatch(setBranchByBusinress(branchIds));
store.dispatch(setUser(user));
const selectedUser = JSON.parse(localStorage.getItem("selectedUser"));
store.dispatch(setSelectedChat(selectedUser));
const userPro = JSON.parse(localStorage.getItem("user-Pro"));
store.dispatch(setUserPro(userPro));
const userRoutes = JSON.parse(localStorage.getItem("user-routes"));
store.dispatch(setUserRoutes(userRoutes));

export default store;
